import { render, staticRenderFns } from "./AddOrEditDirectoryGroup.vue?vue&type=template&id=2bd59fb2&scoped=true"
import script from "./AddOrEditDirectoryGroup.vue?vue&type=script&lang=ts"
export * from "./AddOrEditDirectoryGroup.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditDirectoryGroup.vue?vue&type=style&index=0&id=2bd59fb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd59fb2",
  null
  
)

export default component.exports